import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Flex, Skeleton, Tabs, useMantineColorScheme } from "@mantine/core";

import { Breadcrumbs } from "../../../components/Breadcrumbs";
import { AssignmentTab } from "../../../components/CampaignInquiryDetail";
import { useCampaignInquiry } from "../../../hooks/campaignInquiries";
import { Error404Page } from "../../404";

const defaultTab = "assignment";

export interface CampaignInquiryDetailPageProps {}
export const CampaignInquiryDetailPage = ({}: CampaignInquiryDetailPageProps) => {
    const params = useParams();
    const navigate = useNavigate();
    const { t } = useTranslation(["common"]);

    const { colorScheme } = useMantineColorScheme();

    const tab = params?.tab || defaultTab;

    const { campaignInquiry, isLoadingCampaignInquiry, reloadCampaignInquiry } = useCampaignInquiry(
        params?.campaignInquiryId
    );

    if (isLoadingCampaignInquiry) {
        return <Skeleton />;
    }

    // A cancelled (or otherwise unavailable) inquiry is undiscoverable for the client —
    // the API returns null, so we render the standard "page not found".
    if (!campaignInquiry) {
        return <Error404Page />;
    }

    return (
        <>
            <Flex align="center" justify="space-between" mb="lg">
                <Breadcrumbs
                    items={[
                        {
                            path: "/campaigns/inquiries",
                            title: t("campaigninquiries"),
                        },
                        {
                            title: campaignInquiry?.name,
                        },
                    ]}
                />
            </Flex>
            <Tabs
                color={colorScheme === "dark" ? "orange" : "dark"}
                keepMounted={false}
                value={tab}
                onTabChange={(tab) =>
                    navigate(`/campaigns/inquiry/${params?.campaignInquiryId}${tab === defaultTab ? "" : `/${tab}`}`)
                }
            >
                <Tabs.List>
                    <Tabs.Tab value="assignment">{t("campaign_tab_assignment")}</Tabs.Tab>
                </Tabs.List>
                <Box pb="lg" mt="lg" style={{ flex: 1 }}>
                    <Tabs.Panel value="assignment">
                        <AssignmentTab campaignInquiry={campaignInquiry} />
                    </Tabs.Panel>
                </Box>
            </Tabs>
        </>
    );
};
